import deepSeekAI from '@/views/deepSeekAI/index.vue'

let a = Object.assign({ deepSeekAI })
export default a;